import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useUpdateMutation } from "../../app/services/machines";
import { fetchMachines } from "../../features/machines/machinesSlice";

import { Typography } from "@mui/material";
import {
  ModalButton,
  ModalWrapper,
  ModalErrorDisplay,
} from '../ModalComponents';

export default function ModalConfirmStatusChange({
  isStatusChange,
  setIsStatusChange,
  setIsInputsDisabled,
  fetchData,
  id,
  form,
}) {
  const [errorResponse, setErrorResponse] = useState("");

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleClose = async () => {
    setIsStatusChange(false);
    setIsInputsDisabled(false);
    await fetchData();
  };

  const [updateMachine] = useUpdateMutation();
  const handleSubmit = async () => {
    try {
      const { ...machineData } = form;
      await updateMachine({ id, machineData });
      await fetchData();
      await dispatch(fetchMachines());
      setIsInputsDisabled(false);
      setIsStatusChange(false);
    } catch (error) {
      setErrorResponse(error);
      console.error("Error updating user:", error);
    }
  };

  return (
    <div>
      <ModalWrapper
        open={isStatusChange}
        handleClose={handleClose}
        title={`${t("modals.areSureWant")} ${t("modals.changeStatus")} ${form.status}?`}
        actions={
          <>
            <ModalButton
              variant="outlined"
              color="primary"
              onClick={handleClose}
            >
              {t("modals.cancel")}
            </ModalButton>
            <ModalButton
              variant="contained"
              color="primary"
              onClick={handleSubmit}
            >
              {t("modals.submit")}
            </ModalButton>
          </>
        }
      >
        <Typography color="var(--text-secondary)" variant="body2">
          {t("modals.changeStatusWarning")}
        </Typography>
        <ModalErrorDisplay errorResponse={errorResponse} />
      </ModalWrapper>
    </div>
  );
}
